<template>
    <div>
        <div class="extended_field extended_field-wide" v-for="(field, field_index) in d" v-bind:key="field_index">
 
            <div class="title" v-if="field.title">
                <p v-html="$root.t(field.title)"></p>
            </div>
            
            <label class="info" v-on:click="help = help == field.infotext ? false : field.infotext" v-if="field.infotext && field.type !== 'Hidden'">?</label>

            <label v-html="$root.t(field.name)" v-if="field.type !== 'Hidden'">
            </label>

            <transition name="drop">
                <div  class="infotext" v-if="help == field.infotext && help !== false">
                    <p v-html="$root.t(field.infotext)" ></p>
                </div>
            </transition>

            <input v-model="m[field.id].Field.Content" v-if="field.type === 'Text'" type="text" :name="`wf[${field.id}]`">

            <textarea v-model="m[field.id].Field.Content" v-if="field.type === 'Textarea'" type="text" :name="`wf[${field.id}]`"></textarea>


            <input v-model="m[field.id].Field.Content" v-if="field.type === 'date'  || field.type === 'Zahl'" placeholder="dd.mm.YYYY" type="text" :name="`wf[${field.id}]`">


            <div class="select-wrapper" v-if="field.type === 'TypologySelect'">
                <select v-model="m[field.id].Field.Content[0]" :name="`wf[${field.id}]`">
                    <option 
                        v-for="(field_option, field_optkey) in field.value" 
                        v-bind:key="field_optkey" 
                        v-html="field_option.translation ? field_option.translation[$root.language] : field_option" 
                        :value="field_option.id ? field_option.id : field_optkey"
                        :selected="(field_option.id ? field_option.id : field_optkey)==m[field.id].Field.Content[0]?'true':'false'"
                    />
                </select>
            </div>

            <div class="select-wrapper select-wrapper-multiple" v-if="field.type === 'TypologySelectMultiple'">
                <select v-model="m[field.id].Field.Content" :name="`wf[${field.id}]`" multiple>
                    <option 
                        v-for="(field_option, field_optkey) in field.value" 
                        v-bind:key="field_optkey" 
                        v-html="field_option.translation ? field_option.translation[$root.language] : field_option" 
                        :value="field_option.id ? field_option.id : field_optkey"
                        :selected="m[field.id].Field.Content[field_option.id ? field_option.id : field_optkey]?'selected':'false'"
                    />
                </select>
            </div>

            <div class="autoselect" v-if="field.type === 'ajax_provider'">
                <table class="table autoselect-table">
                    <tr v-for="rId in m[field.id].Field.Content" v-if="m[field.id].Reference && m[field.id].Reference[rId]">
                        <td>
                            <span  v-html="field.template(m[field.id].Reference[rId])"></span>
                        </td>
                        <td><a v-on:click="autoselect_remove(rId, m[field.id])" class="tag remove"></a></td>
                    </tr>
                </table>
                <div class="autoselect-ajax">
                    <input type="text"  :placeholder="$root.t(`editor:${field.id}:placeholder`)" v-on:keyup="field.provider(field, $event)">
                    <div class="autoselect-ajax-scroll" v-if="field.value.Documents">
                        <div v-if="field.value.Documents.length == 0" v-html="$root.t(`editor:${field.id}:infotext`)">
                        </div>
                        <template v-else>
                            <a
                                v-for="field_option in field.value.Documents" 
                                :key="field_option.Contribution.id" 
                                v-on:click="field.value = autoselect_add(field_option, m[field.id])"
                            ><span v-html="field_option._html" ></span>
                            </a>
                        </template>
                    </div>
                </div>              
            </div>              

            <div class="radio" v-if="field.type === 'radio'" v-for="(field_option, field_optkey) in field.value"  v-bind:key="field_optkey">
                <label v-html="$root.t(field_option)"></label>
                <input v-model="m[field.id].Field.Content" type="radio" :name="`wf[${field.id}]`" :value="field_option"/>
            </div>
            
            <div class="radio" v-if="field.type === 'checkbox'">
                <label v-html="$root.t(field.value)"></label>
                <input v-model="m[field.id].Field.Content" type="checkbox" :name="`wf[${field.id}]`"/>
            </div>
        
            <div class="divider" v-if="field.divider === true"/>

        </div>
    </div>          
</template>

<script>

import _ from 'lodash'
import Vue from 'vue'
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
 

export default {
  name: 'EditorFormField',
  props: ['values', 'data', 'model'],
  data () {
      return {
          d: this.data,
          m: this.model,
          help: false,
      }
  },
  methods: {
    intersection(a,b) {
        return _.intersection(a, b).length > 0 ? true : false
    },
    remove(table, row) {
        table.splice(row, 1);
    },
    add(table, cellcount) {
        let _newrow = [];
        for (let index = 0; index < cellcount; index++) {
            _newrow[index] = "";
        }
        table.push(_newrow);
    },
    autoselect_add(contribution, model) {
        model.Field.Content = model.Field.Content || [];
        if (model.Field.Content == -1) model.Field.Content = [];
        model.Reference = model.Reference || {};
        if (typeof model.Field.Content == 'string') {
            model.Field.Content = [model.Field.Content]
        }
        model.Field.Content.push(contribution.Contribution.Id);
        model.Reference[contribution.Contribution.Id] = contribution.Data;
        return {};
    },
    autoselect_remove(id, model) {
        if (id != this.$root.logindata.userid || confirm(this.$root.t('editor:deleteown'))) {
            delete model.Reference[id];
            var index = model.Field.Content.indexOf(id);
            if (index !== -1) model.Field.Content.splice(index, 1);            
        }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">


</style>



      